if (!customElements.get('pet-rug-customizer')) {
  customElements.define('pet-rug-customizer', class PetRugCustomizer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.form = this.closest('form');
      this.nameInput = this.querySelector('[name="properties[Pet name]"]');
      this.typeInput = this.querySelector('[name="properties[Pet type]"]');
      this.frontInput = this.querySelector('[data-pet-rug-file="front"]');
      this.sideInput = this.querySelector('[data-pet-rug-file="side"]');
      this.notesInput = this.querySelector('[name="properties[Pet rug artwork notes]"]');
      this.sameConfirm = this.querySelector('[name="properties[Photo set confirmed]"]');
      this.permissionConfirm = this.querySelector('[name="properties[Photo permission confirmed]"]');
      this.counter = this.querySelector('[data-pet-rug-count]');

      if (!this.form || !this.nameInput || !this.typeInput || !this.frontInput || !this.sideInput || !this.notesInput || !this.sameConfirm || !this.permissionConfirm) return;

      this.allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
      this.maxBytes = 15 * 1024 * 1024;
      this.cacheKey = 'mofabia-pet-rug-' + (this.dataset.productId || 'project');
      window.mofabiaPetRugDrafts = window.mofabiaPetRugDrafts || {};
      const saved = window.mofabiaPetRugDrafts[this.cacheKey];

      if (saved) {
        this.nameInput.value = saved.name || '';
        this.typeInput.value = saved.type || '';
        this.notesInput.value = saved.notes || '';
        this.sameConfirm.checked = Boolean(saved.same);
        this.permissionConfirm.checked = Boolean(saved.permission);
      }

      this.nameInput.addEventListener('input', () => {
        this.saveDraft();
        this.clearError('name', this.nameInput);
      });

      this.typeInput.addEventListener('change', () => {
        this.saveDraft();
        this.clearError('type', this.typeInput);
      });

      this.notesInput.addEventListener('input', () => {
        this.updateCounter();
        this.saveDraft();
      });

      [['front', this.frontInput], ['side', this.sideInput]].forEach(([key, input]) => {
        input.addEventListener('change', () => {
          this.updateFileState(key, input);
          this.validateFile(key, input, false);
        });
      });

      this.sameConfirm.addEventListener('change', () => {
        this.saveDraft();
        this.clearError('same', this.sameConfirm);
      });

      this.permissionConfirm.addEventListener('change', () => {
        this.saveDraft();
        this.clearError('permission', this.permissionConfirm);
      });

      this.form.addEventListener('submit', (event) => {
        if (!this.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);

      this.updateCounter();
    }

    updateCounter() {
      if (this.counter) this.counter.textContent = String(this.notesInput.value.length);
    }

    saveDraft() {
      window.mofabiaPetRugDrafts[this.cacheKey] = {
        name: this.nameInput.value,
        type: this.typeInput.value,
        notes: this.notesInput.value,
        same: this.sameConfirm.checked,
        permission: this.permissionConfirm.checked
      };
    }

    updateFileState(key, input) {
      const label = input.closest('.pet-rug-customizer__upload');
      const filename = this.querySelector('[data-pet-rug-filename="' + key + '"]');
      const file = input.files && input.files[0];

      if (filename) filename.textContent = file ? file.name : (key === 'front' ? 'Choose front photo' : 'Choose side photo');
      if (label) label.classList.toggle('is-selected', Boolean(file));
    }

    clearError(key, input) {
      input.removeAttribute('aria-invalid');
      const error = this.querySelector('[data-pet-rug-error="' + key + '"]');
      const label = input.closest('.pet-rug-customizer__upload');
      if (error) error.textContent = '';
      if (label) label.classList.remove('is-invalid');
    }

    setError(key, input, message) {
      input.setAttribute('aria-invalid', 'true');
      const error = this.querySelector('[data-pet-rug-error="' + key + '"]');
      const label = input.closest('.pet-rug-customizer__upload');
      if (error) error.textContent = message;
      if (label) label.classList.add('is-invalid');
    }

    validateFile(key, input, required) {
      this.clearError(key, input);
      const file = input.files && input.files[0];

      if (!file) {
        if (required) this.setError(key, input, key === 'front' ? 'Upload one clear front-facing photo.' : 'Upload one clear side-view or full-body photo.');
        return !required;
      }

      if (!this.allowedTypes.includes(file.type)) {
        this.setError(key, input, 'Choose a JPG, PNG or WebP image.');
        input.value = '';
        this.updateFileState(key, input);
        return false;
      }

      if (file.size > this.maxBytes) {
        this.setError(key, input, 'Choose an image smaller than 15 MB.');
        input.value = '';
        this.updateFileState(key, input);
        return false;
      }

      return true;
    }

    validate() {
      let valid = true;
      const name = this.nameInput.value.trim();

      this.clearError('name', this.nameInput);
      this.clearError('type', this.typeInput);
      this.clearError('same', this.sameConfirm);
      this.clearError('permission', this.permissionConfirm);

      if (!name) {
        this.setError('name', this.nameInput, 'Enter your pet name.');
        valid = false;
      }

      if (!this.typeInput.value) {
        this.setError('type', this.typeInput, 'Choose your pet type.');
        valid = false;
      }

      if (!this.validateFile('front', this.frontInput, true)) valid = false;
      if (!this.validateFile('side', this.sideInput, true)) valid = false;

      if (!this.sameConfirm.checked) {
        this.setError('same', this.sameConfirm, 'Confirm that both photos show the same pet.');
        valid = false;
      }

      if (!this.permissionConfirm.checked) {
        this.setError('permission', this.permissionConfirm, 'Confirm that you have permission to use the photos.');
        valid = false;
      }

      if (!valid) {
        const firstInvalid = this.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
      }

      return valid;
    }
  });
}